import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { Carousel } from 'react-responsive-carousel';
import {
  FIDELIZE_BROKER_FEATURES_COOKIE,
  checkBonusJourneyEligibility,
  checkTermAcceptBonusJourney
} from '@plataforma/utils';

import * as BannersComponents from '../Banners';

import { Container, CaroulselIndicator, Indicator } from './styles';

function CarouselWrapper({ banners }) {
  const [currentBanner, setCurrentBanner] = useState(0);
  const [isEligible, setEligibility] = useState(false);
  const [isAcceptTerm, setIsAcceptTerm] = useState(false);
  const [autoPlay, setAutoplay] = useState(false);

  useEffect(() => {
    const checkEligibility = async () => {
      const eligible = await checkBonusJourneyEligibility();
      setEligibility(eligible);
    };

    checkEligibility();
  }, []);

  useEffect(() => {
    const checkAcceptTerm = async () => {
      const acceptTerm = await checkTermAcceptBonusJourney();
      setIsAcceptTerm(acceptTerm);
    };

    checkAcceptTerm();
  }, []);

  useEffect(() => {
    setTimeout(() => setAutoplay(true), 1000);
  });

  const getBannerName = banner => {
    return banner && banner.name ? banner.name : '';
  };
  const getBannerComponent = banner => {
    const ComponentName = getBannerName(banner);
    const Component = BannersComponents[ComponentName];
    const bonusJourneyBanners = ['BonusJourney'];
    const documentBanners = ['Banner662'];
    const fidelizeBanners = ['FidelizeBanner', 'FidelizePromotionalBanner'];
    if (Component && bonusJourneyBanners.includes(ComponentName)) {
      const { isAcceptTermContent, isEligibleContent } = banner.dynamicContent;
      const currentContent =
        isAcceptTerm && isAcceptTermContent
          ? isAcceptTermContent
          : isEligibleContent;

      if (!currentContent.showContent) {
        return null;
      }

      return (
        <Component
          key={banner.name}
          currentContent={currentContent}
          isAcceptTerm={isAcceptTerm}
        />
      );
    }
    if (Component && documentBanners.includes(ComponentName)) {
      const props = isAcceptTerm
        ? banner.isEligibleContent
        : banner.isEligibleContent;

      return (
        <Component
          key={banner.name}
          image={banner.image}
          document={banner.document}
          circleShapeVisible={banner.circleShapeVisible}
          buttonVisible={banner.buttonVisible}
          {...props}
        />
      );
    }
    if (Component && fidelizeBanners.includes(ComponentName)) {
      const props = banner.dynamicContent;
      return (
        <Component
          key={banner.name}
          redirectButtonVisible={banner.redirectButtonVisible}
          {...props}
        />
      );
    }
    return Component ? <Component key={banner.name} /> : null;
  };

  const treatBanners = () => {
    const filteredBanners = banners.filter(item => {
      if (item.checkBonusJourneyEligibility && !isEligible) {
        return null;
      }
      if (getBannerName(item) === 'FidelizePromotionalBanner') {
        const cookieData =
          Cookies.getJSON(FIDELIZE_BROKER_FEATURES_COOKIE) || null;
        if (
          item.featureFlag !== null &&
          (cookieData === null ||
            !cookieData.features.includes(item.featureFlag))
        ) {
          return null;
        }
      }

      return item && item.show && getBannerComponent(item);
    });
    const orderedBanners = filteredBanners.sort((a, b) => a.index - b.index);
    return orderedBanners;
  };

  const treatedBanners = treatBanners();

  return (
    banners.length > 0 && (
      <Container data-testid="carousel">
        <Carousel
          autoPlay={autoPlay}
          infiniteLoop
          interval={5000}
          onChange={value => setCurrentBanner(value)}
          selectedItem={currentBanner}
          showArrows={false}
          showIndicators={false}
          showStatus={false}
          showThumbs={false}
        >
          {treatedBanners.map(item => getBannerComponent(item))}
        </Carousel>

        <CaroulselIndicator>
          {treatedBanners.map((item, index) => (
            <Indicator
              key={`${item.name}-${index}`}
              data-testid={`carousel-banner-${index}`}
              active={index === currentBanner}
              onClick={() => setCurrentBanner(index)}
            />
          ))}
        </CaroulselIndicator>
      </Container>
    )
  );
}

export default CarouselWrapper;

CarouselWrapper.defaultProps = {
  banners: []
};

CarouselWrapper.propTypes = {
  banners: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number,
      show: PropTypes.bool
    })
  )
};
